import CallButton from './CallButton';
import ChatButton from './ChatButton';

export default function MobileBar() {
  return (
    <div className="mobile-bar" role="complementary" aria-label="Quick help">
      <CallButton block>Call</CallButton>
      <ChatButton block>Chat Now</ChatButton>
    </div>
  );
}
